// extracted by mini-css-extract-plugin
export default {"caruselContainer":"HomeCarusel_caruselContainer__PCw32","SwiperSlide":"HomeCarusel_SwiperSlide__d5CcC"};